import { createContext, useContext, type ReactNode } from "react";

interface PreviewModeState {
  isPreview: boolean;
}

const PreviewModeContext = createContext<PreviewModeState>({
  isPreview: false,
});

interface PreviewModeProviderProps {
  children: ReactNode;
  isPreview: boolean;
}

export function PreviewModeProvider({
  children,
  isPreview,
}: PreviewModeProviderProps) {
  return (
    <PreviewModeContext.Provider value={{ isPreview }}>
      {children}
    </PreviewModeContext.Provider>
  );
}

export function usePreviewMode(): PreviewModeState {
  return useContext(PreviewModeContext);
}
